import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import { useBrowserTabTitle } from "go-core/components/BrowserTab/useBrowserTabTitle";
import { LoadingContainer } from "go-core/components/Loading";
import { partnerApi } from "../../../../../../../../services/Api/Partner/partnerApi";
import { PartnerActionTypes, PartnerApi } from "../../../../../../../../services/Api/Partner/partnerTypes";
import { selectPartner } from "../../../../../../../../services/partner/selectors";
import PartnerPreview from "./components/PartnerPreview";

const PartnerPreviewIndexPage = () => {
	const [partner, setPartner] = useState<PartnerApi | undefined>(undefined);
	const { addFlash } = useFlash();
	const dispatch = useDispatch();
	const partnerId = useSelector(selectPartner)?.id;
	const params = {
		include: "codes,users,organizations,provisions,organizations.provisions,custom_fields,parent,any_sub_partner",
	};
	const { t } = useTranslation("admin");
	const { handleChangeTabTitle } = useBrowserTabTitle();

	useEffect(() => {
		fetchPartner();
	}, []);

	const fetchPartner = async () => {
		try {
			const res = await partnerApi.getPartner(Number(partnerId), params);
			setPartner(res);
			dispatch({
				type: PartnerActionTypes.SET,
				payload: res,
			});
			handleChangeTabTitle(
				`${res.name} | ${t("common.word.partner")} | ${t("modules.partner.field.partner_panel.title")}`
			);
		} catch (err) {
			handleError.alert(err, addFlash);
		}
	};

	if (!partner) {
		return <LoadingContainer />;
	}

	return <PartnerPreview partner={partner} />;
};
export default PartnerPreviewIndexPage;
